import { useMutation } from '@apollo/client'
import { VerifyTikTokAuthDocument } from '../../generated/backendGraphql'
import { ReactNode, useEffect } from 'react'
import { PageLoading, toast } from '@bounty/creators-design-system'
import { LOCALSTORAGE_TIKTOK_OAUTH_REDIRECT_URL } from '../../hooks/useTikTok/useTikTok'
import AsyncStorage from '@react-native-async-storage/async-storage'
import { useRouter } from 'solito/router'

type RequireVerifiedTikTokProps = {
  redirectToOnAuthSuccess: string
  children: ReactNode
}

export const RequireVerifiedTikTok = ({
  redirectToOnAuthSuccess,
  children,
}: RequireVerifiedTikTokProps) => {
  // Always go to network because we want this to be up to date
  const [mutation, { loading, data }] = useMutation(VerifyTikTokAuthDocument, {
    fetchPolicy: 'network-only',
  })
  const navigate = useRouter()

  useEffect(() => {
    const checkTikTok = async () => {
      const { data } = await mutation()

      if (!data) {
        toast.error({
          title: 'Error verifying TikTok.',
          message: 'Could not check tiktok verify status. Please try against.',
        })
        return
      }

      if (data.verifyTikTokAuth === false) {
        await AsyncStorage.setItem(
          LOCALSTORAGE_TIKTOK_OAUTH_REDIRECT_URL,
          redirectToOnAuthSuccess,
        )

        navigate.push('/verify-tiktok')
      }
    }

    checkTikTok()
  }, [mutation, navigate, redirectToOnAuthSuccess])

  if (loading || !data || data?.verifyTikTokAuth === false) {
    return <PageLoading />
  }

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{children}</>
}
